module.exports = __webpack_public_path__ + "static/img/Nima.Alavi.48e6085.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Nima.Alavi.jpg
// module id = 1KZX
// module chunks = 0